angular.module("componentes").controller("NumberFieldV3Ctrl", [
	"$scope",
	"clientService",
	function ($scope, clientService) {
		"use strict";

		$scope.onBlur = function () {
			if ($scope.ctrl.onBlur) {
				$scope.ctrl.onBlur($scope.ctrl.field);
			}
		};

		this.$onInit = function () {
			const decimals = clientService.getDecimalPlaces();
			$scope.decimals = $scope.ctrl.decimals || $scope.ctrl.decimals === 0 ? $scope.ctrl.decimals : decimals;
		};
	}
]);
